class KronosError extends Error {
  constructor(message) {
    super(message);

    // Maintenir dans la pile une trace adéquate de l'endroit où l'erreur a été déclenchée (disponible seulement en V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KronosError);
    }
    this.name = "KronosError";
  }
}

export {KronosError}
